import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  moreTo?: string;
  moreLabel?: string;
  align?: "left" | "center";
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  moreTo,
  moreLabel = "查看全部",
  align = "left",
}: SectionHeadingProps) {
  return (
    <div
      className={`mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between ${
        align === "center" ? "sm:flex-col sm:items-center sm:text-center" : ""
      }`}
    >
      <div>
        {eyebrow && (
          <p className="mb-2 flex items-center gap-2 text-xs font-medium tracking-widest text-primary-600">
            <span className="h-3 w-1 rounded-full bg-primary-500" />
            {eyebrow}
          </p>
        )}
        <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">{title}</h2>
        {desc && <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">{desc}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="flex shrink-0 items-center gap-1 whitespace-nowrap text-sm font-medium text-foreground-700 transition-colors hover:text-primary-600"
        >
          {moreLabel}
          <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}